import './TimeAgo.css';

export function TimeAgo({ iso }) {
  const entryd = new Date(iso);
  const ts = iso ? new Date(iso).getTime() : null;
  if (!ts) return '';

  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60000);

  let label;
  let cls;
  switch (true) {
    case m < 1:
      label = 'just now';
      cls = 'timeago timeago--fresh';
      break;
    case m < 60:
      label = `${m}m ago`;
      cls = 'timeago timeago--fresh';
      break;
    case m / 60 < 24:
      label = `${Math.floor(m / 60)}h ago`;
      cls = 'timeago timeago--fresh';
      break;
    case m / 60 / 24 < 7:
      label = `${Math.floor(m / 60 / 24)}d ago`;
      cls = 'timeago timeago--recent';
      break;
    default:
      label = `${Math.floor(m / 60 / 24)}d ago`;
      cls = 'timeago timeago--stale';
  }

  return (
    <span className={cls}>
      •
      <time dateTime={entryd.toISOString()} title={entryd.toLocaleString()}>
        {label}
      </time>
    </span>
  );
}
